import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[appTemplateContext]',
  standalone: true,
})
export class TemplateContextDirective<T> {
  @Input()
  appTemplateContext?: T;

  // Angular reads this signature to narrow the template context; the parameters are its contract, not used at runtime
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static ngTemplateContextGuard<T>(_dir: TemplateContextDirective<T>, _ctx: unknown): _ctx is T {
    return true;
  }
}
